<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.operatingSystem }}</div>
      <div class="col-sm-3">{{ result.text }}</div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
      </div>
    </div>
  </div>
</template>

<script>
import UAParser from 'ua-parser-js'
import CheckerStatus from './CheckerStatus'

const checkerName = 'operating-system'

export default {
  name: checkerName,
  data () {
    return {
      status: 'in-progress',
      result: {
        value: '',
        text: ''
      },
      i18n: window.SYSTEM_CHECK.i18n
    }
  },
  components: {
    CheckerStatus
  },
  created () {
    this.$emit('initialized', {name: checkerName})
  },
  mounted () {
    var os = new UAParser().getResult().os
    this.result.text = os.name + ' ' + os.version
    var supportedOSs = ['Android', 'iOS', 'Mac OS', 'Windows']
    this.result.value = supportedOSs.indexOf(os.name) >= 0 ? 'passed' : 'failed'
    this.$emit('completed', {name: checkerName, result: this.result.text})
  }
}
</script>



// WEBPACK FOOTER //
// OperationSystem.vue?7db38a3c